var catNav = document.getElementById('guide-cat-nav');

if (catNav) {
  var catNavCta = document.getElementById('category-header-cta'),
    catTitle = document.getElementById('category-header-title'),
    catLogo = document.getElementById('category-header-logo'),
    catName = document.getElementById('category-header-name'),
    catDropdown = document.getElementById('tax-category__dropdown--toggle'),
    catMenu = document.getElementById('tax-category__nav--menu'),
    catCaret = document.getElementById('tax-category__dropdown--caret'),
    promoBar = document.getElementById('promo-notification'),
    isGuideSingle = document.body.classList.contains('single-guide'),
    guideBannerSection = document.getElementById('guideBannerSection'),
    stickyTop = catNav.offsetTop;
    
  window.addEventListener(
    'scroll',
    function (e) {
      singlePageArticle = document.getElementById('singlePageArticle');

      if (window.innerWidth >= 980) {
        if (window.pageYOffset >= stickyTop + (promoBar ? promoBar.offsetHeight : 0)) {
          catNav.classList.add('sticky-header');
          catNavCta.classList.add('active');
          catTitle.classList.add('active');
          catLogo.classList.add('active');
          catName.classList.add('active');
        } else {
          catNav.classList.remove('sticky-header');
          catNavCta.classList.remove('active');
          catTitle.classList.remove('active');
          catLogo.classList.remove('active');
          catName.classList.remove('active');
        }

        if (isGuideSingle && guideBannerSection) {
          if (window.pageYOffset >= singlePageArticle.offsetTop - 63) {
            catNav.style.top = "0";
          } else {
            catNav.style.top = "-300px";
          }
        }
      }
    },
    false
  );

  //Category Dropdown
  catDropdown.addEventListener('click', function (e) {
    e.preventDefault();
    catMenu.classList.toggle('tax-category__dropdown--dd-toggle');
    catCaret.classList.toggle('active');
  });

  //Link Click WebTracker Event
  var catLinks = catNav.querySelectorAll('a');
  for (var i = 0; i < catLinks.length; i++) {
    catLinks[i].addEventListener('click', function (e) {
      WebEventTracker.logEvent(EDS.webEvents, 'ClickedOnGuideNav', {
        action: this.getAttribute('title'),
      });
    });
  }

  //Assign primary-category class for guide pages
  if (document.body.classList.contains('single-guide')) {
    var catPrimaryCat = catNav.querySelector('li.menu-item-primary-category'),
      catMenuParent = catNav.querySelector('li.current-menu-parent.active');

    if (!catPrimaryCat && catMenuParent) {
      catMenuParent.classList.add('menu-item-primary-category');
    }

    var taxSearchInputBox = document.getElementById('tax-category-search-input'),
      taxInputHandle = document.getElementById('tax-category-search-input-handle'),
      taxSearchInputBoxType = taxSearchInputBoxFocus = true;

    if (taxSearchInputBox && taxInputHandle) {
      document.addEventListener('keyup', function (e) {
        if (e.key !== '/' || e.ctrlKey || e.metaKey) return;
        if (/^(?:input|textarea|select|button)$/i.test(e.target.tagName)) return;

        e.preventDefault();
        taxSearchInputBox.focus();
      });

      taxSearchInputBox.addEventListener('focus', function (e) {
        if (taxSearchInputBoxFocus) {
          WebEventTracker.logEvent(EDS.webEvents, 'ClickedOnGuideNav', {
            action: 'Search Focus',
          });
          taxSearchInputBoxFocus = false;
        }
      });

      taxSearchInputBox.addEventListener('keyup', function (e) {
        if (!e.target.value) {
          taxInputHandle.classList.add('hide');
        } else {
          taxInputHandle.classList.remove('hide');
          lazyLoading.show();
        }

        if (taxSearchInputBoxType) {
          WebEventTracker.logEvent(EDS.webEvents, 'ClickedOnGuideNav', {
            action: 'Search Type',
          });
          taxSearchInputBoxType = false;
        }
      });

      window.validateDocSearchForm = function () {
        var searchText = taxSearchInputBox.value.trim();
        if (searchText !== '') {
          WebEventTracker.logEvent(EDS.webEvents, 'ClickedOnGuideNav', {
            action: 'Search Submit',
            searchText: searchText,
          });
          return true;
        }
        return false;
      };
    }
  }
}
